import type { WebReducerState } from '../reducers/types';

const getPubnubClient = (state: WebReducerState) => state.pubnub.pubnubClient;

export default getPubnubClient;
